import { GetAllPaymentMethodResponseItem } from '@esg/business-setting';
import { GetCustomerDetailResponse } from '@esg/business-crm';
import { Dayjs, getEnv } from '@esg/shared';
import { HttpRequestData, httpUtil } from '@esg/framework';

import { SalePromotionGetDetailResponse, SaleVoucherGetDetailResponse } from '@esg/business-management';

import { SaleDetailGetAllResponseItem } from '../sale-detail';

interface GetDetailSaleRequest extends HttpRequestData {
    readonly pathData: {
        readonly id: string;
    };
}

export enum SaleStatus {
    Unpaid,
    Paid,
    Cancelled
}

export enum UnitEnum {
    Percent = 0,
    Amount = 1
}

export interface CancelReasonSale {
    readonly id: string;
    readonly name: string;
}

export interface SalePayment {
    id?: string;
    saleId: string;
    paymentMethodSettingId?: string;
    payAmount: number;
}

export interface SalePaymentResponse {
    id?: string;
    saleId: string;
    paymentMethodSettingId?: string;
    payAmount: number;
    paymentMethodSetting?: paymentMethodSettingResponse;
    creationTime: Dayjs;
}

export interface paymentMethodSettingResponse {
    id?: string;
    name?: string;
}

export interface SaleTipResponse {
    id?: string;
    employeeId?: string;
    tipAmount: number;
    saleId: string;
    employee?: SaleTipEmployeeResponse;
}

export interface SaleTipEmployeeResponse {
    id?: string;
    fullName?: string;
    avatar?: string;
}

export interface SaleTip {
    id?: string;
    employeeId?: string;
    tipAmount: number;
    saleId: string;
}

export interface CheckoutSaleForm {
    id?: string,
    tip: number;
    tipUnit: UnitEnum;
    salePayments: SalePayment[];
    saleTips: SaleTip[];
    tipAmount: number;
    isPrintBillAfterPayment?: boolean;
    autoDistributeTips: boolean;
}

export interface SaleTipSplitFormValue {
    saleTips: SaleTip[];
}

export interface GetDetailSaleResponse {
    readonly id: string;
    readonly code: string;
    readonly date: Dayjs;
    readonly checkoutAt: Dayjs;
    readonly totalAmount: number;
    readonly tip: number;
    readonly tipUnit: UnitEnum;
    readonly tipAmount?: number;
    readonly discountAmount?: number;
    readonly subTotal: number;
    readonly note?: string;
    readonly cancelNote?: string;
    readonly cancelReasonId?: string;
    readonly cancelReason?: CancelReasonSale;
    readonly taxAmount: number;
    readonly subTotalDetail: number;
    readonly paymentMethodSettingId?: string;
    readonly paymentMethodSetting?: GetAllPaymentMethodResponseItem;
    readonly status: SaleStatus;
    readonly customerId?: string;
    readonly customer?: GetCustomerDetailResponse;
    readonly saleDetails?: SaleDetailGetAllResponseItem[];
    readonly isActive: boolean;
    readonly paidFromScheduler?: boolean;
    readonly salePromotions?: SalePromotionGetDetailResponse[];
    readonly saleVouchers?: SaleVoucherGetDetailResponse[];
    readonly saleTips?: SaleTipResponse[];
    readonly salePayments?: SalePaymentResponse[];
}

export const getDetailSale = httpUtil.createHttpRequestMeta<GetDetailSaleRequest, GetDetailSaleResponse>({
    baseUrl: () => getEnv().MANAGEMENT_SERVER,
    path: '/api/v1/sales/:id',
    method: 'GET',
    authentication: 'bearer'
});